// Self-booking via Jane's Google Calendar appointment schedule. Paste the
// booking page URL from Calendar → appointment schedule → Share → Website
// embed (the iframe src). Until it's set the section doesn't render.
const BOOKING_URL = "";

export default function Booking() {
  if (!BOOKING_URL) return null;

  return (
    <section id="book" className="bg-[#f9fafb] px-6 py-16 md:px-10 md:py-24">
      <div className="mx-auto w-full max-w-5xl space-y-10">
        <div className="space-y-6 text-center">
          <p className="font-nunito font-bold text-xs uppercase tracking-[0.2em] text-sage-deep">
            Book a session
          </p>
          <h2 className="text-4xl md:text-5xl font-trirong_light text-ink">
            Choose a time that suits you…
          </h2>
        </div>
        <iframe
          src={BOOKING_URL}
          title="Book a counselling session"
          className="h-[600px] w-full rounded-lg border-0 bg-white md:h-[700px]"
          loading="lazy"
        ></iframe>
      </div>
    </section>
  );
}
